/**
 * Actualiza la imagen del producto en el modal Quick Shop cuando cambia la variante
 */
(function() {
  'use strict';
  
  function updateQuickShopImage(variantId) {
    const modal = document.querySelector('.t4s-modal--is-active');
    if (!modal) return;
    
    const qsImage = modal.querySelector('.t4s-qs-variant-image');
    if (!qsImage) return;
    
    // Buscar el JSON de variantes en el contenedor del formulario (está fuera del form)
    const formContainer = modal.querySelector('.t4s-product-form__variants');
    let variantsJson = null;
    
    if (formContainer) {
      variantsJson = formContainer.querySelector('.pr_variants_json');
    }
    
    // Si no se encuentra, buscar en todo el modal
    if (!variantsJson) {
      variantsJson = modal.querySelector('.pr_variants_json');
    }
    
    // Si aún no se encuentra, obtener desde la API de Shopify
    if (!variantsJson) {
      const productId = qsImage.dataset.productId;
      if (!productId) return;
      
      // Obtener producto desde API de Shopify
      fetch('/products/' + productId + '.js')
        .then(response => response.json())
        .then(product => {
          const variant = product.variants.find(v => v.id === parseInt(variantId));
          if (variant && variant.featured_image) {
            updateImageFromVariant(qsImage, variant);
          }
        })
        .catch(function() {});
      return;
    }
    
    try {
      const variants = JSON.parse(variantsJson.textContent);
      const variant = variants.find(v => v.id === parseInt(variantId));
      
      if (!variant || !variant.featured_image) return;
      
      updateImageFromVariant(qsImage, variant);
      
    } catch (e) {
      // Error silencioso
    }
  }
  
  function updateImageFromVariant(qsImage, variant) {
    let imageUrl = null;
    if (typeof variant.featured_image === 'string') {
      imageUrl = variant.featured_image;
    } else if (variant.featured_image.src) {
      imageUrl = variant.featured_image.src;
    } else if (variant.featured_image.url) {
      imageUrl = variant.featured_image.url;
    }
    
    if (!imageUrl) return;
    
    const baseUrl = imageUrl.split('?')[0];
    const extMatch = baseUrl.match(/\.(jpg|jpeg|png|webp|gif)/i);
    if (!extMatch) return;
    
    const extension = extMatch[1];
    const srcset = [
      baseUrl.replace(/\.(jpg|jpeg|png|webp|gif)/i, '_400x.' + extension) + ' 400w',
      baseUrl.replace(/\.(jpg|jpeg|png|webp|gif)/i, '_600x.' + extension) + ' 600w',
      baseUrl.replace(/\.(jpg|jpeg|png|webp|gif)/i, '_800x.' + extension) + ' 800w'
    ].join(', ');
    
    qsImage.style.opacity = '0.5';
    qsImage.style.transition = 'opacity 0.3s ease';
    
    setTimeout(function() {
      qsImage.src = baseUrl.replace(/\.(jpg|jpeg|png|webp|gif)/i, '_600x.' + extension);
      qsImage.srcset = srcset;
      qsImage.alt = variant.title || '';
      
      qsImage.onload = function() {
        qsImage.style.opacity = '1';
      };
      qsImage.onerror = function() {
        qsImage.style.opacity = '1';
      };
    }, 150);
  }
  
  function setupListeners() {
    const modal = document.querySelector('.t4s-modal--is-active');
    if (!modal || !modal.querySelector('.t4s-product-quick-shop')) return;
    
    const variantSelect = modal.querySelector('select[name="id"]');
    if (variantSelect && !variantSelect.dataset.qsImageListener) {
      variantSelect.dataset.qsImageListener = 'true';
      variantSelect.addEventListener('change', function() {
        if (this.value) {
          updateQuickShopImage(this.value);
        }
      });
    }
    
    const swatchContainer = modal.querySelector('.t4s-swatch');
    if (swatchContainer && !swatchContainer.dataset.qsImageListener) {
      swatchContainer.dataset.qsImageListener = 'true';
      swatchContainer.addEventListener('click', function(e) {
        const swatchItem = e.target.closest('[data-swatch-item]');
        if (swatchItem) {
          setTimeout(function() {
            const select = modal.querySelector('select[name="id"]');
            if (select && select.value) {
              updateQuickShopImage(select.value);
            }
          }, 300);
        }
      });
    }
  }
  
  // Escuchar evento variant:changed con jQuery si está disponible
  if (typeof jQuery_T4NT !== 'undefined') {
    jQuery_T4NT(document).on('variant:changed', function(evt) {
      const modal = document.querySelector('.t4s-modal--is-active');
      if (!modal || !modal.querySelector('.t4s-product-quick-shop')) return;
      
      if (evt.currentVariant && evt.currentVariant.id) {
        updateQuickShopImage(evt.currentVariant.id);
      } else {
        const select = modal.querySelector('select[name="id"]');
        if (select && select.value) {
          updateQuickShopImage(select.value);
        }
      }
    });
  }
  
  // También escuchar con addEventListener estándar
  document.addEventListener('variant:changed', function(evt) {
    const modal = document.querySelector('.t4s-modal--is-active');
    if (!modal || !modal.querySelector('.t4s-product-quick-shop')) return;
    
    let variantId = null;
    if (evt.currentVariant && evt.currentVariant.id) {
      variantId = evt.currentVariant.id;
    } else if (evt.detail && evt.detail.currentVariant && evt.detail.currentVariant.id) {
      variantId = evt.detail.currentVariant.id;
    } else {
      const select = modal.querySelector('select[name="id"]');
      if (select && select.value) {
        variantId = select.value;
      }
    }
    
    if (variantId) {
      updateQuickShopImage(variantId);
    }
  });
  
  // Observar cuando se abre el modal
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('t4s-modal--is-active')) {
          setTimeout(function() {
            setupListeners();
            const select = target.querySelector('select[name="id"]');
            if (select && select.value) {
              updateQuickShopImage(select.value);
            }
          }, 500);
        }
      }
      
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        const modal = document.querySelector('.t4s-modal--is-active');
        if (modal && modal.querySelector('.t4s-product-quick-shop')) {
          setTimeout(setupListeners, 300);
        }
      }
    });
  });
  
  const modalElement = document.querySelector('.t4s-modal');
  if (modalElement) {
    observer.observe(modalElement, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();
